import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

// The Material "article" (BOL document) and "local_shipping" (number on vehicle) glyphs of the OCR designs
// (Figma 16362:41459), at 12px. The glyphs are drawn on a 24-unit grid with their edges on odd units, which at 12px land
// on half pixels and blur on 1x screens. Moving the viewBox by one unit (half a pixel) puts those edges on whole pixels.
// local_shipping has its top edge on an even unit, so it only moves sideways.
const ICON_STYLE = { fontSize: 12 };

export const BolDocumentIcon = () => <ArticleOutlinedIcon viewBox="-1 -1 24 24" style={ICON_STYLE} aria-hidden="true" />;

export const VehicleNumberIcon = () => <LocalShippingOutlinedIcon viewBox="-1 0 24 24" style={ICON_STYLE} aria-hidden="true" />;
